module.exports = __webpack_public_path__ + "img/Ma.Maritime.Quaywalls.Caissons-18m-width15.5.Dredgedfillmaterial.ee5c43a1.png";